import React, { useCallback, useState, useEffect } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { EmbeddedCheckoutProvider, EmbeddedCheckout } from "@stripe/react-stripe-js";
import PropTypes from "prop-types";
import apiClient from "../../../utils/apiClient";

const stripePromise = loadStripe(
  import.meta.env.VITE_API_STRIPE_TOKEN || "pk_test_8hM4I5gZ0ocpgnvtOrgROi1J00kqrCPrP6",
);

const EmbeddedCheckoutComponent = ({ priceId, onBack, propertyId, checkoutType = "property" }) => {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setMounted(true), 50);
    return () => {
      clearTimeout(timer);
      setMounted(false);
    };
  }, [priceId]);

  useEffect(() => {
    if (typeof window !== "undefined" && checkoutType) {
      window.sessionStorage.setItem("cyt_checkout_type", checkoutType);
    }
  }, [checkoutType]);

  const fetchClientSecret = useCallback(async () => {
    try {
      const { data } = await apiClient.post("/transactions/checkout", {
        price_id: priceId,
        property_id: propertyId || null,
      });

      return data.client_secret;
    } catch (error) {
      console.error("Error al crear la sesión de checkout:", error);
      throw error;
    }
  }, [priceId, propertyId]);

  const options = {
    fetchClientSecret,
  };

  return (
    <div className="w-full max-w-4xl mx-auto">
      <div className="mb-6">
        <button
          onClick={onBack}
          className="text-gray-600 hover:text-gray-900 flex items-center gap-2 mb-4 cursor-pointer hover:underline"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z"
              clipRule="evenodd"
            />
          </svg>
          Cambiar de plan
        </button>
        <p className="text-gray-600 mt-2">
          Completa tu información para procesar el pago de forma segura
        </p>
      </div>

      <div id="checkout" className="w-full">
        {mounted && (
          <EmbeddedCheckoutProvider stripe={stripePromise} options={options}>
            <EmbeddedCheckout />
          </EmbeddedCheckoutProvider>
        )}
      </div>
    </div>
  );
};

EmbeddedCheckoutComponent.propTypes = {
  priceId: PropTypes.string.isRequired,
  onBack: PropTypes.func.isRequired,
  propertyId: PropTypes.string,
  checkoutType: PropTypes.oneOf(["property", "subscription"]),
};

export default EmbeddedCheckoutComponent;
